import React from 'react';
// @NOTE-RT: Must be imported before all the `@mui/*` packages per https://mui.com/material-ui/experimental-api/classname-generator/#setup
import './ClassNameGenerator';
import {
  DeprecatedThemeOptions,
  ThemeProvider,
  adaptV4Theme,
  createTheme,
} from '@mui/material/styles';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ThemeProvider as MaterialUi4ThemeProvider, ThemeOptions } from '@material-ui/core';
import _ from 'lodash';

import { theme as originalMaterialUi4Theme } from 'containers/App/theme';

interface Props {
  children: React.ReactNode;
  themeOverride?: ThemeOptions;
}

export const MuiProvider = ({ children, themeOverride = {} }: Props) => {
  const materialUi4Theme = _.merge({}, originalMaterialUi4Theme, themeOverride);
  const materialUi5Theme = createTheme(
    adaptV4Theme(
      _.merge(
        {},
        {
          ...originalMaterialUi4Theme,
          // For some reason we don't want to inherit original styles from V4 theme, except for the Button
          overrides: {
            MuiButton: originalMaterialUi4Theme.overrides?.MuiButton,
          },
        },
        themeOverride
      ) as DeprecatedThemeOptions
    )
  );
  return (
    <MaterialUi4ThemeProvider theme={materialUi4Theme}>
      <ThemeProvider theme={materialUi5Theme}>
        <LocalizationProvider dateAdapter={AdapterMoment}>{children}</LocalizationProvider>
      </ThemeProvider>
    </MaterialUi4ThemeProvider>
  );
};
